// extracted by css-extract-rspack-plugin
export default {"cancelBtn":"cancelBtn-E6Gkf4","formField":"formField-MgzQNG","fieldInput":"fieldInput-msUH2d"};